<template>
  <div class="mob-remove-table-fixed">
    <Card>
      <appoint ref="appoint"></appoint>
      <search isDisplay='none' :isOperatorDisplay="true" ref="search"></search>
      <workSheetTable ref="workSheetTableRef" :tableColumns="tableColumns" :status="status"></workSheetTable>
    </Card>
    <Modal v-model="ProcessModal" title="处理完成" @on-cancel="cancelProcessModal">
      <Form :models="ProcessForm" :label-width="60" ref="ProcessForm">
        <FormItem label="回复" prop="message">
          <Input type="textarea" v-model="ProcessForm.message" placeholder="回复提交人（可选）" />
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input type="textarea" v-model="ProcessForm.remark" placeholder="如备注工单完成的时长，可在导出的时候选择该字段导出（选填）" />
        </FormItem>
        <FormItem label="归档标记" prop="process_flag">
          <Input type="textarea" v-model="ProcessForm.process_flag" placeholder="必须填写资产编号【要与PM项目管理系统保持一致】。如果该工单为多个资产，需要用逗号','分隔来填写" :maxlength="250" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button :loading="Processing" type="primary" @click="ProcessOk">提交</Button>
      </div>
    </Modal>
    <!-- <Modal v-model="rateModal" title="评价">
      <div style="text-align: center">
        <Form :label-width="80" label-position="left">
          <FormItem label="是否解决" style="text-align: left">
            <RadioGroup v-model="result">
              <Radio label="1">已解决</Radio>
              <Radio label="2">未解决</Radio>
            </RadioGroup>
            <br>
            <span v-if="result==='2'">如问题未解决，评价完成后可重新提交普通工单</span>
          </FormItem>
          <FormItem label="评分" style="text-align: left">
            <Rate v-model="rate"/>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submitRate" :loading="rating">提交</Button>
      </div>
    </Modal> -->
  </div>
</template>

<script>
import search from './components/search'
import workSheetTable from './components/workSheetTable'
import appoint from './components/appoint'
import moment from 'moment'
import { ProcessApi } from '../../api/logistics/worksheet'
import { RateApi } from '../../api/logistics/message'

export default {
  name: 'accepted',
  components: {
    'search': search,
    'workSheetTable': workSheetTable,
    appoint
  },
  data () {
    return {
      status: [2],
      wsid: '',
      rateModal: false,
      result: '1',
      rate: 5,
      rating: false,
      tableColumns: [
        {
          title: '工单编号',
          align: 'center',
          width: 200,
          key: 'wsid'
        },
        {
          title: '提交人',
          align: 'center',
          width: 160,
          key: 'submitter',
          render: (h, params) => {
            if (params.row.count > 0) {
              return h('div', [
                h('span', params.row.submitter),
                h('Badge', {
                  props: {
                    count: params.row.count
                  }
                })
              ])
            }
            return h('span', params.row.submitter)
          }
        },
        {
          title: '标题',
          align: 'center',
          minWidth: 300,
          key: 'title'
        },
        {
          title: '工单类型',
          align: 'center',
          width: 150,
          key: 'type',
          render: (h, params) => {
            let result = ''
            if (params.row.type) {
              result = params.row.type.type_name
            }
            return h('span', result)
          }
        },
        {
          title: '提交时间',
          align: 'center',
          width: 160,
          key: 'c_time',
          render: (h, params) => {
            if (params.row.c_time) {
              return h('div', moment(params.row.c_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '受理人',
          align: 'center',
          width: 100,
          key: 'receive_people_name'
        },
        {
          title: '受理时间',
          align: 'center',
          width: 160,
          key: 'a_time',
          render: (h, params) => {
            if (params.row.a_time) {
              return h('div', moment(params.row.a_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '处理人',
          align: 'center',
          width: 100,
          key: 'operator_name'
        },
        {
          title: '处理组',
          align: 'center',
          width: 100,
          key: 'operator_group'
        },
        {
          title: '状态',
          align: 'center',
          width: 150,
          render: (h, params) => {
            return h('span', '处理中')
          }
        },
        {
          title: '操作',
          width: 180,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$refs.workSheetTableRef.detail(params.row.id)
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                attrs: {
                  disabled: params.row.source === '在线客服'
                },
                on: {
                  click: () => {
                    this.$refs.appoint.show(params.row)
                  }
                }
              }, '指派'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                attrs: {
                  disabled: params.row.source === '在线客服'
                },
                on: {
                  click: () => {
                    this.ProcessForm.id = params.row.id
                    this.ProcessModal = true
                    this.wsid = params.row.wsid
                    this.rateModal = true
                  }
                }
              }, '完成')
            ])
          }
        }
      ],
      ProcessModal: false,
      ProcessForm: {
        id: '',
        message: '',
        remark: '',
        process_flag: ''
      },
      Processing: false
    }
  },
  activated () {
    this.status = [2]
    this.$refs.search.searchSubmit()
    this.$refs.workSheetTableRef.close()
  },
  methods: {
    submitRate () {
      this.rating = true
      RateApi({ wsid: this.wsid, rate: this.rate, result: this.result }).then(res => {
        this.rating = false
        const result = res.data
        if (result.code === 200) {
          this.rateModal = false
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
      }).catch(err => {
        console.log(err)
        this.rating = false
      })
    },
    ProcessOk () {
      if(this.ProcessForm.process_flag === ''){
        this.$Notice.error({
          title: '归档标记 必填',
          desc: '请填写 归档标记'
        })
        return
      }

      this.Processing = true
      ProcessApi(this.ProcessForm).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.$refs.workSheetTableRef.init()
          this.cancelProcessModal()
          this.ProcessModal = false
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
        this.Processing = false
      }).catch(_ => {
        this.Processing = false
      })
    },
    cancelProcessModal () {
      this.ProcessForm = {
        id: '',
        message: '',
        remark: '',
        process_flag: ''
      }
    }
  }
}
</script>

<style scoped>

</style>
